import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService, HttpService } from '../../tms-shared/services';

@Injectable({
  providedIn: 'root',
})
export class LogoutService extends BaseService {
  constructor(protected httpService: HttpService) {
    super('Identity/Logout', httpService);
  }

  logout(): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Logout`, undefined);
  }
}
